import { Libraries, useJsApiLoader } from '@react-google-maps/api';
import React, { createContext, useContext } from 'react';

const libraries: Libraries = ['places', 'visualization'];

type GoogleMapsContextType = {
  isLoaded: boolean;
  loadError: Error | undefined;
};

const GoogleMapsContext = createContext<GoogleMapsContextType | undefined>(undefined);

type GoogleMapsProviderProps = {
  children: React.ReactNode;
};

export const GoogleMapsProvider = ({ children }: GoogleMapsProviderProps) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.VITE_APP_GOOGLE_MAPS_API_KEY!,
    libraries
  });

  return <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>{children}</GoogleMapsContext.Provider>;
};

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (context === undefined) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};
